import { MFNames } from './MFNames';

export const MFFolders = {
	[MFNames.efr]: 'efr',
	[MFNames.efrFast]: 'efr-fast',
	[MFNames.efrCommon]: 'efr-common',
	[MFNames.apiReki]: 'api-reki',
	[MFNames.apiEfr]: 'api-efr',
	[MFNames.designTokens]: 'design-tokens',
	[MFNames.reki]: 'reki',
	[MFNames.common]: 'common',
	[MFNames.uiKit]: 'ui-kit',
	[MFNames.staticFiles]: 'static-files',
};

export type MFFoldersKeys = keyof typeof MFFolders;

export const MFFoldersToName = Object.fromEntries(
	Object.entries(MFFolders).map((a) => a.reverse()),
) as Record<string, MFFoldersKeys>;
